import { render, staticRenderFns } from "./ClientToDoTab.htm?vue&type=template&id=4d5fb4a8&"
import script from "./ClientToDoTab.ts?vue&type=script&lang=js&"
export * from "./ClientToDoTab.ts?vue&type=script&lang=js&"
import style0 from "../MyJobsTab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports